module.exports = __webpack_public_path__ + "components/media-kit/static/sbban-desktop-5036a789c44e6302cbac44a6b908e47a.png";